import { siteName } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-primary-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                {siteName}
              </span>
            </div>
            <p className="text-xs md:text-sm text-background-50/50 font-body leading-relaxed mb-4">
              网红黑料网——国内领先的网红八卦内幕与塌房丑闻爆料聚合平台。每日更新最新网红黑料，覆盖全网3000+网红的塌房翻车动态，从感情八卦到商业丑闻，从人设崩塌到法律纠纷，为千万吃瓜群众提供最快最全的网红黑料资讯。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快捷导航</h4>
            <nav className="flex flex-col gap-2.5">
              {[
                { label: '最新黑料', href: '#cards' },
                { label: '专题合集', href: '#index' },
                { label: '热门话题', href: '#topics' },
                { label: '焦点深扒', href: '#carousel' },
                { label: '热度榜单', href: '#ranking' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-xs md:text-sm text-background-50/50 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer no-underline"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <nav className="flex flex-col gap-2.5">
              {[
                { label: '关于本站', href: '#about' },
                { label: '投稿爆料', href: '#contact' },
                { label: '吃瓜问答', href: '#faq' },
                { label: '移动吃瓜', href: '#app' },
                { label: '吃瓜热评', href: '#comments' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-xs md:text-sm text-background-50/50 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer no-underline"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs md:text-sm text-background-50/40 font-body leading-relaxed">
              合作伙伴信息即将上线，敬请期待
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/50 cursor-pointer hover:text-primary-400 hover:bg-primary-500/20 transition-colors duration-200">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/50 cursor-pointer hover:text-primary-400 hover:bg-primary-500/20 transition-colors duration-200">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/50 cursor-pointer hover:text-primary-400 hover:bg-primary-500/20 transition-colors duration-200">
                <i className="ri-bilibili-line text-lg"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/30 font-label">
            &copy; 2026 {siteName}. All rights reserved.
          </p>
          <p className="text-xs text-background-50/30 font-label">
            本站内容仅供娱乐参考，请理性吃瓜，不传播未经证实的信息
          </p>
        </div>
      </div>
    </footer>
  );
}